export const pixelBasedPredictiveAudienceTransformerToGW = ({ name, audienceSeedId, ...rest }) => ({
    label: name,
    seedId: audienceSeedId,
    ...rest,
    isVisible: true,
});
